import React, { FC, InputHTMLAttributes } from 'react';
import '../form.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface InputDatePickerProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  Controller: any;
  control?: any;
  placeholder?: string;
  label?: string;
  error?: any;
  register?: any;
  wrapperClass?: string;
  className?: string;
  isClearable?: boolean;
  disabled?: boolean;
  isTime?: boolean;
  minDate?: Date;
}

const InputDatePicker: FC<InputDatePickerProps> = ({
  placeholder,
  Controller,
  control,
  name,
  error,
  label,
  wrapperClass,
  isClearable = false,
  disabled = false,
  isTime = false,
  minDate,
  ...rest
}) => {
  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className="text-neutral7 uppercase" htmlFor={name}>
          {label}
        </label>
      )}
      {isTime ? (
        <Controller
          control={control}
          name={name}
          {...rest}
          render={({ field: { onChange, value } }: any) => {
            return (
              <DatePicker
                className="input"
                wrapperClassName="w-full"
                placeholderText={placeholder}
                onChange={onChange}
                selected={value}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                // isClearable={isClearable}
                // disabled={disabled}
              />
            );
          }}
        />
      ) : (
        <Controller
          control={control}
          name={name}
          {...rest}
          render={({ field: { onChange, value } }: any) => {
            return (
              <DatePicker
                className="input"
                wrapperClassName="w-full"
                placeholderText={placeholder}
                onChange={onChange}
                selected={value}
                dateFormat="MM-dd-yyyy"
                isClearable={isClearable}
                disabled={disabled}
                minDate={minDate}
              />
            );
          }}
        />
      )}
      {error && (
        <span className="error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default InputDatePicker;
